// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"SubmissionLoader_loaderWrapper__N6pX5","dotLoader":"SubmissionLoader_dotLoader__vHJp0","l7":"SubmissionLoader_l7__7kCPL"};